import { observable, computed } from "mobx";
import { ActionStore } from "higher-order/ActionStore";
import includes from "lodash/includes";

export default class RoleStore extends ActionStore {
    @observable roles = null;

    @computed
    get hasOpsAdminRole() {
        return includes(this.roles, "operations-admins");
    }

    @computed
    get hasIntranetAdminRole() {
        return includes(this.roles, "intranet-admins");
    }

    @computed
    get hasMakerCheckerUserRole() {
        return includes(this.roles, "makercheckerusers");
    }

    @computed
    get hasMakerCheckerAdminRole() {
        return includes(this.roles, "makercheckeradmins");
    }

    @computed
    get hasSuperAdminRole() {
        return includes(this.roles, "super-admin");
    }

    constructor(props, dispatcher) {
        super(dispatcher);
        if (props.roles) {
            // Format roles to lowercase and replace spaces with dashes
            this.roles = props.roles.map(role => 
                role.toLowerCase().replace(/\s+/g, '-')
            );
        }
    }
}
